// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"d79d59ee","444":"90d3afa1","514":"d79d59ee","659":"d79d59ee","742":"d79d59ee"}[chunkId] + ".chunk.css";
};